 <template>
  <div>
    <marketplace-card-slider v-model="selectedMarketplace" class="pa-3"/>

    <component
      :is="activeComponent"
      v-if="activeComponent && selectedMarketplace"
      :store_id="selectedMarketplace?.store_id"
      :title="selectedMarketplace.title"
      :type="selectedMarketplace.type"
    />
  </div>
</template>

<script>
import MarketplaceCardSlider from '../../components/MarketplaceCardSlider.vue';
import ProductList from '../woocommerce/productList.vue';
import ProductVarient from './productVarient.vue';
import numbersList from '@/view/pages/numbers/numbersList.vue';
import PhysicalProductList from "@/view/pages/phycialStore/PhysicalProductList.vue";

export default {
  name: 'ProductVarientAll',
  components: {
    MarketplaceCardSlider,
    ProductVarient,
    numbersList,
    PhysicalProductList,
    ProductList
  },
  data: () => ({
    selectedMarketplace: null,
    items: [
      { type: 'digikala', component: 'ProductVarient' },
      { type: 'divar', component: 'numbersList' },
      { type: 'physical_store', component: 'PhysicalProductList' },
      { type: 'woocommerce', component: 'ProductList' },
    ],
  }),
  computed: {
    activeComponent() {
      if (!this.selectedMarketplace || !this.selectedMarketplace.type) return null;
      const found = this.items.find((x) => x.type === this.selectedMarketplace.type);
      return found ? found.component : null;
    },
  },
};
</script>
